import { Component } from '@angular/core';
import { NavController, NavParams ,ToastController , ModalController} from 'ionic-angular';
import { Api } from "../../providers/api";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Headers , RequestOptions } from '@angular/http';
import { SearchCustomersPage } from "../search-customers/search-customers";
import {SelectionSearchPage} from '../selection-search/selection-search';
import { SelectionSearchService } from '../../services/selection-search' ;
import  {LoginPage} from '../login/login';
import { MsgManager } from '../../providers/msg-manager';
import {GVLogger} from "../../services/gv-logger";


@Component({
  selector: 'page-edit-customer',
  templateUrl: 'edit-customer.html'
})
export class EditCustomerPage {


  userNameError = "";
  formStatus = false;

  countriesList: any;

  stateList1: any;
  cityList1: any;

  stateList2: any;
  cityList2: any;

  address1Country:any;
  address1State:any;
  address1City:any;

  address2Country:any;
  address2State:any;
  address2City:any;

  taxGroupList:any;
  customerGroupList:any;
  paymentTermsList:any;


  taxGroup:string;
  customerGroup:string;


  states1SelectControl:boolean = false;
  cities1SelectControl:boolean = false;

  states2SelectControl:boolean = false;
  cities2SelectControl:boolean = false;

	public form:any ;
	public customerMinimized : any;
	public customer: any = {
		id:0,
		customerId:"",
		name: "",
    userName:"",
    password:"",
		company:"",
		locationsDTOs: [{
			addressLine1:"",
			addressLine2:"",
			city:"",
			state:"",
			zipCode:"",
			country:"",
			receiverName:""
		},
		{
			addressLine1:"",
			addressLine2:"",
			city:"",
			state:"",
			zipCode:"",
			country:"",
			receiverName:""
		}]
	};

  constructor(public navCtrl: NavController,
  public navParams: NavParams,
  public api:Api ,
  public formBuilder:FormBuilder,
  public toastController:ToastController,
  public modalController:ModalController,
  public ss:SelectionSearchService,
  private msgManager:MsgManager,
  private gVLogger: GVLogger) {

    this.loadTaxGroups();
    this.loadCustomerGroups();
    this.loadPaymentTerms();




  	this.form ={
  		company:"",
  		name:"",
  		email:"",
      userName:"",
      password:"",
  		phone:"",
      taxGropup:"",
      customerGroup:"",
  		isPrimary:false,
  		adress1name:"",
  		address1street: "",
  		address1city:"",
  		address1state:"",
  		adddress1zip:"",
  		address1country:"",
  		isSameAsAbove: false,
  		adress2name:"",
  		address2street: "",
  		address2city:"",
  		address2state:"",
  		adddres21zip:"",
  		address2country:""
  	}
  	this.customerMinimized  = this.navParams.get("customerMinimized");
  	this.getCustomerById(this.customerMinimized.id);



   this.getLookupCountries();

  }

  ionViewDidLoad() {
    this.gVLogger.log('ionViewDidLoad EditCustomerPage');

  }


  getCustomerById(id){

  	this.api.get("customers/"+id).map(res => res.json()).subscribe(result=>{
  		this.gVLogger.log(JSON.stringify(result.data));
  		if(result.status == "200"){

        let bool:Array<boolean> = [false,true];

  			this.customer = result.data;

  			this.form.company = this.customer.company;
  			this.form.name = this.customer.name;
  			this.form.email = this.customer.email;
        this.form.userName = this.customer.userName;
        this.form.password = this.customer.password;
  			this.form.phone = this.customer.phone;
        this.form.taxGroup = this.customer.taxGroup;
        this.form.customerGroup = this.customer.customerGroup;



        this.gVLogger.log(this.form.taxGroup);
        this.gVLogger.log(this.form.customerGroup);


  			if(this.customer.locationsDTOs.length > 0 ){


	  			this.form.address1name = this.customer.locationsDTOs[0].receiverName;
	  			this.form.address1city = this.customer.locationsDTOs[0].city;
	  			this.form.address1street = this.customer.locationsDTOs[0].addressLine1 ;
	  			this.form.address1state = this.customer.locationsDTOs[0].state;
	  			this.form.address1zip = this.customer.locationsDTOs[0].zipCode;
	  			this.form.address1country = this.customer.locationsDTOs[0].country;
          this.loadProvincesByCountryCode1(this.form.address1country);
          this.loadCitiesByProvinceCode1(this.form.address1state);
          this.states1SelectControl = true;
          this.cities1SelectControl = true;

	  			if(this.customer.locationsDTOs[0].locationType == "BILLTOSHIPTO"){
		  			this.form.isSameAsAbove = true;
		  			this.form.address1name = this.customer.locationsDTOs[0].receiverName;
		  			this.form.address1city = this.customer.locationsDTOs[0].city;
		  			this.form.address1street = this.customer.locationsDTOs[0].addressLine1;
		  			this.form.address1state = this.customer.locationsDTOs[0].state;
		  			this.form.address1zip = this.customer.locationsDTOs[0].zipCode;
		  			this.form.address1country = this.customer.locationsDTOs[0].country;
            this.form.isPrimary = bool[this.customer.locationsDTOs[0].isShipToAddress];
            this.states1SelectControl = true;
            this.cities1SelectControl = true;
	  			}else if( this.customer.locationsDTOs[1] != null){
	  				this.form.address2name = this.customer.locationsDTOs[1].receiverName;
		  			this.form.address2city = this.customer.locationsDTOs[1].city;
		  			this.form.address2street = this.customer.locationsDTOs[1].addressLine1;
		  			this.form.address2state = this.customer.locationsDTOs[1].state;
		  			this.form.address2zip = this.customer.locationsDTOs[1].zipCode;
		  			this.form.address2country = this.customer.locationsDTOs[1].country;
            this.loadCitiesByProvinceCode2(this.form.address2state);
            this.loadProvincesByCountryCode2(this.form.address2country);
            this.states2SelectControl = true;
            this.cities2SelectControl = true;
	  			}

  			}


  			}else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }




  			this.gVLogger.log(JSON.stringify(this.form));
  	});
  }



  updateCustomer(){

    this.validateForm();

    if(this.formStatus){




          var locations = [];
    let locationShipto = {
      receiverName: this.form.address1name,
      addressLine1: this.form.address1street,
        addressLine2: "",
        city: this.form.address1city,
        state: this.form.address1state,
        zipCode: this.form.address1zip,
        country: this.form.address1country,
        isShipToAddress: 1,
        locationType: "SHIPTO"
    }
    if(this.form.isSameAsAbove) {
      locationShipto.locationType = "BILLTOSHIPTO";
      locations.push(locationShipto);
    }else{
      let locationBillto = {
        receiverName: this.form.address2name,
      addressLine1: this.form.address2street,
        addressLine2: "",
        city: this.form.address2city,
        state: this.form.address2state,
        zipCode: this.form.address2zip,
        country: this.form.address2country,
        isShipToAddress: 0,
        locationType: "BILLTO"
    }

      locations.push(locationShipto);
      locations.push(locationBillto);
    }

    var postJSON = {
     id:this.customer.id,
     company:this.form.company,
     name: this.form.name,
     phone: this.form.phone,
     taxGroup: this.form.taxGroup,
     customerGroup: this.form.customerGroup,
     email: this.form.email,
     salesPersonCode: this.customer.salesPersonCode,
     shippingServiceDTOsc:this.customer.shippingServiceDTOs,
     locationsDTOs: locations
    }

    this.gVLogger.log(JSON.stringify(this.form));

  let headers = new Headers({
        'Content-Type': 'application/json'
      });
      let options = new RequestOptions({
        headers: headers
      });

    this.formStatus = false;
    this.api.post("customers/add",JSON.stringify(postJSON),options)
    .map(res => res.json())
      .subscribe(data => {
    if(data.status == "200"){
      this.msgManager.toastMsg("Customer Updated Successful");
      this.navCtrl.setRoot(SearchCustomersPage);
    }else if(data.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }
      });
    }else{

      this.presentToast("Please fill all the required fields","bottom");
    }

  }

  loadProvincesByCountryCode1(countryCode1){
    this.api.get("lookup/codesByCode?codeString="+countryCode1).map(res => res.json()).subscribe(result=>{
      this.gVLogger.log(result);
      if(result.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

        this.navCtrl.setRoot(LoginPage);
      }
      if(result.status == "200"){
        this.gVLogger.log("loadbycode"+result);
        this.stateList1 = result.data;
      }
    });
  }

  loadCitiesByProvinceCode1(provinceCode1){
  this.api.get("lookup/codesByCode?codeString="+provinceCode1).map(res => res.json()).subscribe(result=>{
        this.gVLogger.log(result);
        if(result.status == "200"){
          this.gVLogger.log("loadbycode"+result);
          this.cityList1 = result.data;
        }else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }
      });
  }

  loadProvincesByCountryCode2(countryCode2){
    this.api.get("lookup/codesByCode?codeString="+countryCode2).map(res => res.json()).subscribe(result=>{
      this.gVLogger.log(result);
      if(result.status == "200"){
        this.gVLogger.log("loadbycode"+result);
        this.stateList2 = result.data;
      }else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }
    });
  }

  loadCitiesByProvinceCode2(provinceCode2){
  this.api.get("lookup/codesByCode?codeString="+provinceCode2).map(res => res.json()).subscribe(result=>{
        this.gVLogger.log(result);
        if(result.status == "200"){
          this.gVLogger.log("loadbycode"+result);
          this.cityList2 = result.data;
        }else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }
      });
  }


  getLookupCountries(){

    this.api.get("lookup/codesByTable?tableName=country").map(res => res.json()).subscribe(result=>{
      this.gVLogger.log(result);
      if(result.status == "200"){
        this.countriesList = result.data;
      }else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }
    });

  }


  country1Changed(){

    this.gVLogger.log(this.form.address1country);
    let countryId = this.form.address1country;

    this.api.get("lookup/codesByCode?codeString=" + countryId).map(res => res.json()).subscribe(result=>{
      this.gVLogger.log(result);
      if(result.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

        this.navCtrl.setRoot(LoginPage);
      }
      if(result.status == "200"){
        this.stateList1 = result.data;
        this.form.address1state = "";
        this.form.address1city = "";

         this.states1SelectControl = true;
         this.cities1SelectControl = false;
      }
    });


  }

  country2Changed(){

    let countryId= this.form.address2country;

    this.api.get("lookup/codesByCode?codeString=" + countryId).map(res => res.json()).subscribe(result=>{
      this.gVLogger.log(result);
      if(result.status == "200"){
        this.stateList2 = result.data;
        this.form.address2state = "";
        this.form.address2city = "";
        this.states2SelectControl = true;
        this.cities2SelectControl = false;
      }else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }
    });


  }

  state1Changed(){

    let provinceId = this.form.address1state;

    this.api.get("lookup/codesByCode?codeString=" + provinceId).map(res => res.json()).subscribe(result=>{
      this.gVLogger.log(result);
      if(result.status == "200"){
        this.cityList1 = result.data;
        this.form.address1city = "";
        this.cities1SelectControl = true;
      }else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }
    });


  }

  state2Changed(){

    let provinceId= this.form.address2state;

    this.api.get("lookup/codesByCode?codeString=" + provinceId).map(res => res.json()).subscribe(result=>{
      this.gVLogger.log(result);
      if(result.status == "200"){
        this.cityList2 = result.data;
        this.form.address2city = "";
        this.cities2SelectControl = true;
      }else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }
    });
  }


  loadTaxGroups(){
    this.api.get("lookup/taxGroups").map(res => res.json()).subscribe(result =>{
      if(result.status == "200"){
        this.taxGroupList = result.data;
      }else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }
    });
  }

  loadCustomerGroups(){
    this.api.get("lookup/customerGroups").map(res => res.json()).subscribe(result =>{
      if(result.status == "200"){
        this.customerGroupList = result.data;
      }else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }
    });
  }


  loadPaymentTerms(){

  this.api.get("lookup/codesByTable?tableName=termsCode").map(res => res.json()).subscribe(result =>{
      if(result.status == "200"){
        this.paymentTermsList = result.data;
      }else if(result.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.navCtrl.setRoot(LoginPage);
        }
    });
  }


 //  checkUsernameUniqeness(){
 //
 //    this.gVLogger.log(this.form.userName +" -- value Check ");
 //   // var body:any = { "query":};
 //
 //    let body = new FormData();
 //    body.append('query', this.form.userName );
 //
 //    let headers = new Headers({
 //        'Content-Type': 'application/json'
 //      });
 //      let options = new RequestOptions({
 //        headers: headers
 //      });
 //
 //      this.gVLogger.log(JSON.stringify(body));
 //    this.api.post('customers/availability',body)
 //      .map(res => res.json())
 //        .subscribe(resp => {
 //          this.gVLogger.log(JSON.stringify(resp));
 //          if(resp.status=="200"){
 //            this.formStatus = true;
 //            this.userNameError = "";
 //            this.validateForm();
 //          }else if(resp.status=="500"){
 //            this.userNameError = "error";
 //            this.formStatus = false;
 //            this.msgManager.toastMsg("Username not available please choose other.");
 //          }else if(resp.status == "401"){ // check for session out
 //          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
 //          this.navCtrl.setRoot(LoginPage);
 //        }
 //        });
 //  }
 //
 //
 // showModalCountry1(){
 //
 //    this.ss.setItemsList(this.countriesList);
 //    this.gVLogger.log("countries : "+  this.ss.getItemsList());
 //    this.ss.setVariableType("country1");
 //    let modal = this.modalController.create(SelectionSearchPage);
 //    modal.onWillDismiss(data => {
 //     this.gVLogger.log("dismiss"+data);
 //     if(data != null){
 //       if(data.viewType == "country1"){
 //         this.form.address1country = data.item.code;
 //         //this.customerCreateForm.controls['address1country'].setValue(data.item.code);
 //         this.gVLogger.log("code"+data.item.code);
 //         //this.gVLogger.log("code form",this.customerCreateForm.controls.address1country._value);
 //        this.country1Changed();
 //       }
 //     }
 //   });
 //    modal.present();
 //  }
 //
 //
 // showModalState1(){
 //    if(this.states1SelectControl){
 //        this.ss.setItemsList(this.stateList1);
 //        this.gVLogger.log("countries : "+  this.ss.getItemsList());
 //        this.ss.setVariableType("state1");
 //        let modal = this.modalController.create(SelectionSearchPage);
 //        modal.onWillDismiss(data => {
 //         this.gVLogger.log("dismiss"+data);
 //         if(data != null){
 //           if(data.viewType == "state1"){
 //             this.form.address1state = data.item.code;
 //             this.gVLogger.log("code"+data.item.code);
 //
 //            this.state1Changed();
 //           }
 //         }
 //       });
 //        modal.present();
 //      }
 //    }
 //
 //    showModalCiy1(){
 //    if(this.cities1SelectControl){
 //        this.ss.setItemsList(this.cityList1);
 //        this.gVLogger.log("countries : "+  this.ss.getItemsList());
 //        this.ss.setVariableType("city1");
 //        let modal = this.modalController.create(SelectionSearchPage);
 //        modal.onWillDismiss(data => {
 //         this.gVLogger.log("dismiss"+data);
 //         if(data != null){
 //           if(data.viewType == "city1"){
 //             this.form.address1city = data.item.code;
 //             this.gVLogger.log("code"+data.item.code);
 //             this.validateForm();
 //           }
 //         }
 //       });
 //        modal.present();
 //      }
 //    }
 //
 //
 //
 //
 //
 //
 //    showModalCountry2(){
 //
 //    this.ss.setItemsList(this.countriesList);
 //    this.gVLogger.log("countries : "+  this.ss.getItemsList());
 //    this.ss.setVariableType("country2");
 //    let modal = this.modalController.create(SelectionSearchPage);
 //    modal.onWillDismiss(data => {
 //     this.gVLogger.log("dismiss"+data);
 //     if(data != null){
 //       if(data.viewType == "country2"){
 //         this.form.address2country = data.item.code;
 //         this.gVLogger.log("code"+data.item.code);
 //
 //        this.country2Changed();
 //       }
 //     }
 //   });
 //    modal.present();
 //  }
 //
 //
 //  showModalState2(){
 //    if(this.states2SelectControl){
 //        this.ss.setItemsList(this.stateList2);
 //        this.gVLogger.log("countries : "+  this.ss.getItemsList());
 //        this.ss.setVariableType("state2");
 //        let modal = this.modalController.create(SelectionSearchPage);
 //        modal.onWillDismiss(data => {
 //         this.gVLogger.log("dismiss"+data);
 //         if(data != null){
 //           if(data.viewType == "state2"){
 //             this.form.address2state = data.item.code;
 //             this.gVLogger.log("code"+data.item.code);
 //            this.state2Changed();
 //           }
 //         }
 //       });
 //        modal.present();
 //      }
 //    }
 //
 //    showModalCiy2(){
 //    if(this.cities2SelectControl){
 //        this.ss.setItemsList(this.cityList2);
 //        this.gVLogger.log("countries : "+  this.ss.getItemsList());
 //        this.ss.setVariableType("city2");
 //        let modal = this.modalController.create(SelectionSearchPage);
 //        modal.onWillDismiss(data => {
 //         this.gVLogger.log("dismiss"+data);
 //         if(data != null){
 //           if(data.viewType == "city2"){
 //             this.form.address2city = data.item.code;
 //             this.gVLogger.log("code"+data.item.code);
 //             this.validateForm();
 //           }
 //         }
 //       });
 //        modal.present();
 //      }
 //    }



validateForm(){

      if(
        this.form.company != "" && // Company Name
        this.form.name != "" &&  // Name Prefix
        this.form.email != "" && // Email
        // this.form.userName != "" && // User Name
        // this.form.password != "" && // Password
        this.form.taxGroup != "" &&  // taxGroup
        this.form.customerGroup != "" &&  // Customer group
        this.form.address1city != "" // city 1  ////////////////
         ){

        // var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
        // // Email validation
        // if (this.customerCreateForm.controls.email._value != "" &&
        //   (this.customerCreateForm.controls.email._value.length <= 5 ||
        //     !EMAIL_REGEXP.test(this.customerCreateForm.controls.email._value))) {
        //     //this.presentToast("Enter a Valid Email","middle");
        //     this.emailError = true;
        //     this.formStatus = false;
        // }else{
           // Form is verified
          this.formStatus = true;
       // }


        }else{
          this.formStatus = false;
        }

    }

    presentToast(msg,position) {
      let toast = this.toastController.create({
        message: msg,
        duration: 3000,
        position: position
      });
      toast.present();
    }

}









// WEBPACK FOOTER //
// ./src/pages/edit-customer/edit-customer.ts